const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
const mobileRegex = /^[6-9]\d{9}$/;
const accountNumberRegex = /^[0-9]{9,18}$/;

const normalizeBadgeValue = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const formatBadgeLabel = (value, fallback = "N/A") => {
  if (value === null || value === undefined) return fallback;

  const normalized = String(value).trim().replace(/[_-]+/g, " ");
  if (!normalized) return fallback;

  return normalized
    .split(/\s+/)
    .map((word) => {
      if (/^[A-Z0-9]{2,5}$/.test(word)) {
        return word.toUpperCase();
      }

      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
};

const getInvoiceStatusBadgeClass = (value) => {
  const normalized = normalizeBadgeValue(value);

  if (normalized === "paid") return "status-paid";
  if (normalized === "unpaid") return "status-unpaid";
  return "status-partial";
};

const getPaymentModeBadgeClass = (value) => {
  const normalized = normalizeBadgeValue(value);

  if (normalized.includes("cash")) return "badge-success";
  if (
    normalized.includes("online") ||
    normalized.includes("upi") ||
    normalized.includes("transfer") ||
    normalized.includes("bank")
  ) {
    return "badge-info";
  }
  if (normalized.includes("cheque") || normalized.includes("check")) {
    return "badge-warning";
  }
  return "badge-neutral";
};

const getVisitorTypeBadgeClass = (value) => {
  const normalized = normalizeBadgeValue(value);

  if (normalized === "new" || normalized === "new visitor") {
    return "badge-warning";
  }
  if (normalized === "existing visitor") {
    return "badge-info";
  }
  return "badge-neutral";
};

const getRoleBadgeClass = (value) => {
  const normalized = normalizeBadgeValue(value);

  if (normalized.includes("admin")) return "badge-success";
  if (normalized.includes("manager") || normalized.includes("lead")) {
    return "badge-info";
  }
  return "badge-neutral";
};

const getStatusToneBadgeClass = (value) => {
  const normalized = normalizeBadgeValue(value);

  if (normalized === "paid") return "badge-success";
  if (normalized === "unpaid") return "badge-danger";
  return "badge-warning";
};

const validateAccountNumber = (val) => {
  if (!val) return "Account number is required";
  if (val.length < 9) return "Account number must be at least 9 digits";
  if (val.length > 18) return "Account number must not exceed 18 digits";
  if (!accountNumberRegex.test(val)) return "Invalid account number (digits only)";
  return "";
};
const validateMobile = (val) => {
    if (!val) return "Mobile number is required";
    if (val.length < 10) return "Mobile number must be exactly 10 digits";
    if (!mobileRegex.test(val))
      return "Invalid mobile number (10 digits, starts with 6-9)";
    return "";
  };
  

const validateGST = (val) => {
  if (!val) return "GST number is required";
  if (val.length < 15) return "GST number must be exactly 15 characters";
  if (val.length > 15) return "GST number must not exceed 15 characters";
  if (!gstRegex.test(val)) return "Invalid GST number format (e.g., 27ABCDE1234F1Z5)";
  return "";
};


const validateIFSC = (val) => {
  if (!val) return "IFSC code is required";
  if (val.length < 11) return "IFSC code must be exactly 11 characters";
  if (val.length > 11) return "IFSC code must not exceed 11 characters";
  if (!ifscRegex.test(val)) return "Invalid IFSC code format (e.g., SBIN0001234)";
  return "";
};
export {
  formatBadgeLabel,
  getInvoiceStatusBadgeClass,
  getPaymentModeBadgeClass,
  getRoleBadgeClass,
  getStatusToneBadgeClass,
  getVisitorTypeBadgeClass,
  validateMobile,
  validateGST,
  validateIFSC,
  validateAccountNumber,
};
